import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './app.vue';
import qs from 'qs';
import jquery from 'jquery';
import axios from 'axios';
import Vuex from 'vuex';
import bkMagic from '@tencent/bk-magic';
import echarts from 'echarts';
import filterXSS from 'xss';
import vClickOutside from 'v-click-outside';
import VueWechatTitle from 'vue-wechat-title';
import markdownItTaskLists from  'markdown-it-task-lists';
import mavonEditor from 'mavon-editor';
import MetaInfo from 'vue-meta';
import './scss/smart-icon/icomoon.js'
var config = require('./js/config');
import {
    Dialog,
    Tag,
    Input,
    Tabs,
    TabPane,
    Tooltip,
    Icon,
    Message,
    Rate,
    Popover,
    Table,
    TableColumn,
    Carousel,
    CarouselItem,
    Button,
    Loading,
    Badge,
    Pagination,
    DatePicker,
    Select,
    Option,
    Radio,
    RadioGroup
} from 'element-ui';
import { openLoginWindow } from './js/smart.js'
Vue.use(mavonEditor);
if (!mavonEditor.markdownIt) {
    mavonEditor.markdownIt = mavonEditor.mavonEditor.getMarkdownIt();
}
mavonEditor.markdownIt.use(markdownItTaskLists);
Vue.use(vClickOutside);
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Input)
Vue.use(MetaInfo);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Button);
Vue.use(Loading);
Vue.use(Tooltip);
Vue.use(Icon);
Vue.use(Rate);
Vue.use(Popover);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Badge);
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(VueWechatTitle);
Vue.prototype.$message = Message;
//富文本编辑
Vue.prototype.$echarts = echarts;
Vue.use(bkMagic);
// filterXSS.whiteList['input'] = ['type', 'src', 'disabled', 'checked', 'class']
filterXSS.whiteList['img'] = ['src', 'alt', 'title'];
filterXSS.whiteList['table'] = ['border', 'align', 'valign'];
filterXSS.whiteList['th'] = ['rowspan', 'colspan', 'align', 'valign'];
filterXSS.whiteList['td'] = ['rowspan', 'colspan', 'align', 'valign'];
filterXSS.whiteList['col'] = ['align', 'valign', 'span'];
filterXSS.whiteList['colgroup'] = ['align', 'valign', 'span'];
filterXSS.whiteList['video'] = [
  'autoplay',
  'controls',
  'crossorigin',
  'loop',
  'muted',
  'playsinline',
  'poster',
  'preload',
  'src'
];
// filterXSS.whiteList['math'] = []
// filterXSS.whiteList['semantics'] = []
// filterXSS.whiteList['mrow'] = []
// filterXSS.whiteList['mtext'] = []
// filterXSS.whiteList['annotation'] = ['encoding']
// filterXSS.whiteList['msub'] = []
// filterXSS.whiteList['mi'] = []
// filterXSS.whiteList['mo'] = []
// filterXSS.whiteList['mn'] = []
// filterXSS.whiteList['li'] = ['class']
// filterXSS.whiteList['span'] = ['class', 'title', 'aria-hidden', 'style']
// filterXSS.whiteList['code'] = []
// filterXSS.whiteList['li'] = ['class', 'id']
// filterXSS.whiteList['td'] = ['style', 'class']
// filterXSS.whiteList['p'] = ['style', 'class']
// filterXSS.whiteList['div'] = ['style', 'class']
// filterXSS.whiteList['a'] = ['style', 'class', 'id', 'target', 'href', 'title']
filterXSS.stripIgnoreTag = true;

Vue.prototype.filterXSS = filterXSS;

// 实现发送csrf_token请求头
//https://gist.github.com/paltman/490049a64fa4115a2cea
//https://www.npmjs.com/package/axios
var axiosDefaults = require("axios/lib/defaults");
axiosDefaults.xsrfCookieName = "smart_csrftoken";
axiosDefaults.xsrfHeaderName = "X-CSRFToken";
// 跨域请求附加COOKIE
axiosDefaults.withCredentials = true;

//X-REQUESTED-WITH: XmlHttpRequest -> django.http.request.is_ajax: self.META.get('HTTP_X_REQUESTED_WITH') == 'XMLHttpRequest'
//var axios_django = axios.create({
//  headers: {'X-REQUESTED-WITH': 'XMLHttpRequest'}
//});

//axios.defaults.headers = {'X-Requested-With': 'XMLHttpRequest'};

// 拦截器：在这里对ajax请求做一些统一公用处理
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 返回 401 清除token信息并跳转到登录页面
                    let err_data = error.response.data;

                    // window.qq_url = err_data.qq_url;
                    // window.wx_url = err_data.wx_url;
                    // window.wx_params = err_data.wx_params;

                    //vuex_store.commit("showLogin");
                    //vuex_store.commit("setQQUrl");
                    //vuex_store.commit("setWeixinUrl");
                    //vuex_store.commit("setWeixinParams");
                    var _src = error.response.data;
                    try{
                        openLoginWindow(_src);
                        // smart.open_login_dialog(_src);
                    }catch(err){
                        console.warn(err)
                    }
                    break;
                case 500:
                    // 异常
                    // alert("系统出现异常, 请记录下错误场景并与开发人员联系, 谢谢!");
                    Vue.prototype.$bkInfo({
                        title: '提示',
                        content: '系统出现异常, 请记录下错误场景并与开发人员联系, 谢谢!',
                        delay: 3000
                    });
                    break;
                case 404:
                    router.push({
                        path: '/s-mart/404'
                    })
                    break;
                case 402:
                    // 用户完善信息弹窗
                    vuex_store.commit("showInformation");
                    // alert("你需要完善信息后才能访问当前功能.");
                    break;
                case 412:
                    vuex_store.commit("showSecondary");
                    break;
                case 405:
                    router.push({
                        path: '/personal_center',
                        query: {redirect: router.history.current.fullPath}
                    })
                    break;
                case 406:
                    Vue.prototype.$bkInfo({
                        title: '提示',
                        content: error.response.data.message,
                        delay: 3000
                    });
                    break;
            }
            return Promise.reject(error.response)
        }
        return Promise.reject(error);   // 返回接口返回的错误信息
    });

window.axios = axios;
window.qs = qs;
window.$ = jquery;
Vue.use(VueRouter);
Vue.use(Vuex);

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

window.Vue = Vue;
if(window.myUrl  == undefined){
    window.myUrl = '/s-mart/';
}

const router = new VueRouter(require('./router'))

let vuex_store = new Vuex.Store({
    state: {
        userInfo: {}, // 用户信息
        loginShow: false,  // 登录弹窗
        secondaryShow: false,  // 二级密码弹窗
        hasEmail: false,       // 重置二级密码 是否具有电子邮箱
        hasPhone: false,        // 重置二级密码 是否具有手机号
        isLogin: false,     // 是否已登陆
        qq_url: '', // qq登录url
        wx_url: '',  // weixin登录url
        wx_params: '',  // weixin登录参数
        informationShow: false,   // 完善信息弹窗
        informationComplete: false, // 信息是否完善
        province: {},
        globalLoading: false,
        verificaPhone: {}
    },
    mutations: {
        getVerificaPhone (state, value) {
            state.verificaPhone = value
        },
        setLoginStatus(state, isLogin) {
            state.isLogin = isLogin
        },
        setUserInfo (state, value) {
            state.userInfo = value;
        },
        setQQUrl(state) {
            state.qq_url = window.qq_url;
        },
        setWeixinUrl(state) {
            state.wx_url = window.wx_url;
        },
        setWeixinParams(state) {
            state.wx_params = window.wx_params;
        },
        showInformation(state) {
            state.informationShow = true;
        },
        updateInformationComplete (state, value) {
            state.informationComplete = value;
        },
        hideInformation(state) {
            state.informationShow = false;
        },
        showSecondary(state) {
            state.secondaryShow = true
            axios.post(myUrl + "profile/user/contact/").then((res) => {
                res = res.data;
                if (res.result) {
                    if (res.data.email !== "") {
                        state.hasEmail = true;
                        // vuex_store.commit("setEmail");
                    }
                    if (res.data.phone !== "") {
                        state.hasPhone = true;
                    }
                }
            })
        },
        hideSecondary(state) {
            state.secondaryShow = false
        },
        showLogin(state) {
            state.loginShow = true;
            //axios.post(myUrl + "profile/user/contact/").then((res) => {
            //  res = res.data;
            //  if (res.result) {
            //    if (res.data.email !== "") {
            //      vuex_store.commit("setEmail");
            //    }
            //  }
            //})
        },
        hideLogin(state) {
            state.loginShow = false;
        },
        setEmail(state) {
            state.hasEmail = true;
        },
        setGlobalLoading(state, globalLoading) {
            state.globalLoading = globalLoading
        }
    },
    getters: {
        loginState: state => {
            return state.loginShow
        },
        secondaryState: state => {
            return state.secondaryShow
        },
        emailState: state => {
            return state.hasEmail
        },
        globalState: state => {
            return state.globalLoading
        }
    }
})
// window.vuex_store = vuex_store

Vue.directive('focus', {
    // 当绑定元素插入到 DOM 中。
    // inserted: function (el) {
    //   // 聚焦元素
    //   el.focus()
    // }
    update (el, binding) {
        if (binding.value !== binding.oldVal) {
            // console.log('binding', binding.value, binding.oldVal, el)
            el.focus()
        }
    }
})


// 全局钩子
router.beforeEach((to, from, next) => {
    // console.log(to, from, next)
    vuex_store.commit("setGlobalLoading", true);
    next();
});
router.afterEach((route) => {
    vuex_store.commit("setGlobalLoading", false);
    if (route.path === "/" || route.path === "/anniversary" || route.path === "/anniversary/enterprise") {
        $(".bk-header").removeClass("bk-header2");
        $(".bk-header-static").removeClass("bk-header2");
    } else {
        $(".bk-header").addClass("bk-header2")
        $(".bk-header-static").addClass("bk-header2")
    }
})

let vm = new Vue({
    el: '#app',
    data: {
        config: config
    },
    store: vuex_store,
    router: router,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js